import React, { useState, useEffect } from 'react';
import { logApi, userApi } from '../../api';
import { useAuth } from '../../context/AuthContext';
import { PageHeader, Table, Pagination, message, formatDate } from '../../components/common';

const AdminLogs = () => {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [logTypes, setLogTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, per_page: 20, total: 0 });
  const [filters, setFilters] = useState({ user_id: user.id, operation_type: '' });
  const [sort, setSort] = useState({ field: 'created_at', order: 'desc' });

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        per_page: pagination.per_page,
        ...filters,
        sort_by: sort.field,
        order: sort.order
      };
      Object.keys(params).forEach(k => !params[k] && delete params[k]);
      const res = await logApi.getList(params);
      setLogs(res.data.items);
      setPagination(prev => ({ ...prev, total: res.data.total }));
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await userApi.getList({ per_page: 100 });
      setUsers(res.data.items);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLogTypes = async () => {
    try {
      const res = await logApi.getTypes();
      setLogTypes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchLogTypes();
  }, []);

  useEffect(() => { fetchLogs(); }, [pagination.page, pagination.per_page, sort]);

  const handleSearch = () => {
    setPagination(prev => ({ ...prev, page: 1 }));
    fetchLogs();
  };

  const handleSort = (field, order) => {
    setSort({ field, order });
  };

  const columns = [
    { key: 'id', title: 'ID', width: '60px', sorter: true },
    { key: 'username', title: '用户' },
    { key: 'real_name', title: '姓名' },
    {
      key: 'operation_type', title: '操作类型', render: (v) => {
        const type = logTypes.find(t => t.value === v);
        return type ? type.label : v;
      }
    },
    { key: 'operation_desc', title: '操作描述' },
    { key: 'ip_address', title: 'IP地址', render: (v) => v || '-' },
    { key: 'created_at', title: '操作时间', render: (v) => formatDate(v), sorter: true },
  ];

  return (
    <div>
      <PageHeader title="操作日志" />

      <div className="search-bar">
        <div className="form-item">
          <select value={filters.user_id} onChange={e => setFilters({ ...filters, user_id: e.target.value })}>
            <option value="">全部用户</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.username} ({u.real_name || '-'})</option>)}
          </select>
        </div>
        <div className="form-item">
          <select value={filters.operation_type} onChange={e => setFilters({ ...filters, operation_type: e.target.value })}>
            <option value="">全部类型</option>
            {logTypes.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
        <button className="btn btn-primary" onClick={handleSearch}>搜索</button>
      </div>

      <Table
        columns={columns}
        data={logs}
        loading={loading}
        sort={sort}
        onSort={handleSort}
      />
      <Pagination current={pagination.page} total={pagination.total} pageSize={pagination.per_page}
        onChange={(page) => setPagination(prev => ({ ...prev, page }))}
        onPageSizeChange={(size) => setPagination(prev => ({ ...prev, per_page: size, page: 1 }))} />
    </div>
  );
};

export default AdminLogs;
